import _ from 'lodash';
import React from 'react';
import postal from 'postal';
import ErrorBoundary from '../../../shared/error-boundary';
import defaultOnErrorHandler from '../../../shared/default-on-error-handler';
import SidebarItem from './common/sidebar-item';
import { getIncompleteDetails } from '../../../services/profiles/personal-details-service';

export default class ProfileEditorSidebar extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      incomplete: false,
    };
  }

  componentDidMount() {
    postal.subscribe({
      channel: 'profile.events',
      topic: 'personal-details-changed',
      callback: () => this.refresh(),
    });

    this.refresh();
  }

  refresh() {
    getIncompleteDetails()
      .then(r => this.setState({ incomplete: _.get(r, 'data.incomplete_details.length') > 0 }))
      .catch(error => defaultOnErrorHandler(error, 'Error finding any incomplete details'));
  }

  render() {
    const isContributorOrEditor = _.get(window, 'Livewire.currentUser.profile.isContributorOrEditor');

    return (
      <ErrorBoundary>
        <ul className="sidebar-menu">
          <SidebarItem
            href="/profiles/me/personal_details"
            text="Personal Details"
            incomplete={this.state.incomplete}
          />
          {isContributorOrEditor && (
            <SidebarItem href="/profiles/me/contributor_profile" text="Contributor Profile" />
          )}
          <SidebarItem href="/profiles/me/investment_information" text="Investment Information" />
          <SidebarItem href="/profiles/me/notification_preferences" text="Email Preferences" />
        </ul>
      </ErrorBoundary>
    );
  }
}
